import React from 'react';

export default () => (
  <svg width="15" height="26" viewBox="0 0 15 26">
    <path fill="none" fillRule="evenodd" stroke="var(--color-black)" strokeWidth="2" d="M.995 1L12.99 12.995.995 24.99" />
  </svg>
);
